{
  "title": "Seguridad",
  "description": "Gestiona tu contraseña, la autenticación en dos pasos y las sesiones activas.",

  "passwordTitle": "Cambiar contraseña",
  "passwordDescription": "Usa una contraseña segura y única para proteger tu cuenta.",
  "currentPasswordLabel": "Contraseña actual",
  "newPasswordLabel": "Nueva contraseña",
  "confirmPasswordLabel": "Confirmar nueva contraseña",
  "passwordHelper": "Usa al menos 8 caracteres.",
  "changePassword": "Actualizar contraseña",
  "passwordChanged": "Contraseña actualizada",
  "passwordChangedDescription": "Tu contraseña se ha cambiado.",
  "passwordError": "No pudimos cambiar tu contraseña.",
  "passwordErrorDescription": "Verifica tu contraseña actual e inténtalo de nuevo.",

  "twoFactorTitle": "Autenticación en dos pasos",
  "twoFactorDescription": "Añade un segundo paso al iniciar sesión para mayor protección.",
  "twoFactorDisabled": "No activada",
  "twoFactorEnabled": "Activada",
  "twoFactorHint": "Usa una app de autenticación para generar códigos de un solo uso.",
  "enableTwoFactor": "Activar dos pasos",
  "disableTwoFactor": "Desactivar 2FA",
  "regenerateCodes": "Regenerar códigos",

  "setupDialogTitle": "Configurar la autenticación en dos pasos",
  "setupDialogDescription": "Escanea el código QR con tu app de autenticación y luego introduce el código de 6 dígitos para confirmar.",
  "qrAlt": "Código QR para tu app de autenticación",
  "secretLabel": "O introduce esta clave manualmente",
  "verifyCodeLabel": "Código de 6 dígitos",
  "verify": "Verificar y activar",
  "verifyError": "Ese código no coincide.",
  "verifyErrorDescription": "Revisa tu app de autenticación e inténtalo de nuevo.",
  "setupError": "No pudimos iniciar la configuración.",
  "setupErrorDescription": "Inténtalo de nuevo en un momento.",

  "recoveryTitle": "Guarda tus códigos de recuperación",
  "recoveryDescription": "Guárdalos en un lugar seguro. Cada código funciona una vez si pierdes acceso a tu autenticador. No se volverán a mostrar.",
  "copyCodes": "Copiar códigos",
  "downloadCodes": "Descargar códigos",
  "codesCopied": "Códigos de recuperación copiados",
  "recoveryDone": "He guardado mis códigos",

  "passwordPromptLabel": "Confirma con tu contraseña",
  "disableConfirmTitle": "¿Desactivar la autenticación en dos pasos?",
  "disableConfirmBody": "Tu cuenta dependerá solo de tu contraseña. Introduce tu contraseña para confirmar.",
  "disableConfirm": "Desactivar 2FA",
  "twoFactorDisabledToast": "Dos pasos desactivado",
  "twoFactorDisabledToastDescription": "La autenticación en dos pasos está desactivada.",
  "disableError": "No pudimos desactivar los dos pasos.",
  "regenerateConfirmTitle": "¿Regenerar los códigos de recuperación?",
  "regenerateConfirmBody": "Tus códigos de recuperación actuales dejarán de funcionar. Introduce tu contraseña para confirmar.",
  "regenerateConfirm": "Regenerar códigos",
  "regenerateError": "No pudimos regenerar tus códigos.",

  "sessionsTitle": "Sesiones activas",
  "sessionsDescription": "Dispositivos con sesión iniciada en tu cuenta.",
  "sessionsEmptyTitle": "No hay otras sesiones activas",
  "sessionsEmptyDescription": "Cuando inicies sesión desde otro dispositivo, aparecerá aquí.",
  "currentSession": "Actual",
  "unknownDevice": "Dispositivo desconocido",
  "signedInAt": "Sesión iniciada el {{date}}",
  "ipLabel": "IP {{ip}}",
  "revoke": "Revocar",
  "revokeConfirmTitle": "¿Cerrar esta sesión?",
  "revokeConfirmBody": "Este dispositivo cerrará la sesión y tendrá que volver a iniciar sesión.",
  "revokeConfirm": "Cerrar sesión",
  "sessionRevoked": "Sesión revocada",
  "sessionRevokedDescription": "Ese dispositivo ha cerrado la sesión.",
  "revokeError": "No pudimos revocar esa sesión.",
  "revokeErrorDescription": "Inténtalo de nuevo en un momento.",
  "sessionsError": "No pudimos cargar tus sesiones.",

  "passwordRequired": "Introduce tu contraseña actual.",
  "passwordTooShort": "Usa al menos 8 caracteres.",
  "passwordMismatch": "Las nuevas contraseñas no coinciden.",
  "codeRequired": "Introduce el código de 6 dígitos.",
  "passwordPromptRequired": "Introduce tu contraseña para confirmar."
}
